import React from 'react'
import { Placeholder, RiverWrapper } from '../GameBoardStyles'
import { CardFront } from '../../card/CardFront'
import { calculateDelay } from '../../card/helpers/calculateDelay'
import { colors } from '../../../lib/colors'

export default function Raise({
  cardsList,
  deal,
  dealOut,
  winPositions,
  showResult,
}: any) {
  return (
    <>
      {cardsList.map((card: any, id: number) => (
        <Placeholder key={id} zIndex={5 - id}>
          <CardFront
            card={card}
            deal={deal}
            dealOut={dealOut}
            animDelay={calculateDelay(id)}
            background={
              showResult && winPositions[id] === '1'
                ? colors.secondary
                : colors.cardWhite
            }
          />
        </Placeholder>
      ))}
    </>
  )
}
